/**
 * Проверяет длину значения для элемента ввода, учитывая пробелы.
 * @param {string | number} value - Значение для проверки длины.
 * @returns {number} Длина значения для элемента ввода.
 */
export const checkLengthForInput = value => {
  let length = 0;

  if (!value) return length;

  String(value)
    .split('')
    .forEach(char => {
      if (/\s/g.test(char)) {
        length += 0.25;
      } else {
        length += 1;
      }
    });

  return length;
};
